// extracted by mini-css-extract-plugin
module.exports = {"root":"_6bd53de","thumb":"_adee4da","switchBase":"_aa4cce7","checked":"_e90e705","track":"_bdf236b"};